import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Group, Checkbox, Input } from "@mantine/core";

const PORTFOLIO_DEFAULTS = {
  realEstate: false,
  stock: false,
  fund: false,
  insurance: false,
  commodities: false,
  options: false,
  business: false,
  other: false,
};

const PORTFOLIO_KEYS = Object.keys(PORTFOLIO_DEFAULTS);

const ClientMajorInvestmentPortfolio = ({
  form: mainForm,
  label = "Major Investment Portfolio",
  disabled = false,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    const portfolio = mainForm.values.majorInvestmentPortfolio;
    if (!portfolio || typeof portfolio !== "object") {
      mainForm.setFieldValue("majorInvestmentPortfolio", {
        ...PORTFOLIO_DEFAULTS,
      });
      return;
    }
    const patch = {};
    PORTFOLIO_KEYS.forEach((key) => {
      if (portfolio[key] === undefined) patch[key] = false;
    });
    if (Object.keys(patch).length > 0) {
      mainForm.setFieldValue("majorInvestmentPortfolio", {
        ...portfolio,
        ...patch,
      });
    }
  }, [mainForm, mainForm.values._id]);

  const checkboxProps = (field) => {
    const props = mainForm.getInputProps(
      `majorInvestmentPortfolio.${field}`,
      { type: "checkbox" }
    );
    return {
      ...props,
      checked: Boolean(props.checked),
    };
  };

  return (
    <Input.Wrapper label={label}>
      <Group mt="xs">
        <Checkbox
          disabled={disabled}
          label={t("Real Estates")}
          {...checkboxProps("realEstate")}
        />
        <Checkbox
          disabled={disabled}
          label={t("Stocks")}
          {...checkboxProps("stock")}
        />
        <Checkbox
          disabled={disabled}
          label={t("Fund")}
          {...checkboxProps("fund")}
        />
        <Checkbox
          disabled={disabled}
          label={t("Insurance")}
          {...checkboxProps("insurance")}
        />
        <Checkbox
          disabled={disabled}
          label={t("Commodities")}
          {...checkboxProps("commodities")}
        />
        <Checkbox
          disabled={disabled}
          label={t("Options")}
          {...checkboxProps("options")}
        />
        <Checkbox
          disabled={disabled}
          label={t("Own Business")}
          {...checkboxProps("business")}
        />
        <Checkbox
          disabled={disabled}
          label={t("Others")}
          {...checkboxProps("other")}
        />
      </Group>
    </Input.Wrapper>
  );
};

export default ClientMajorInvestmentPortfolio;
